import React from "react";
import PropTypes from "prop-types";

import { useToast } from "../../hooks/useToast";
import { useMutation } from "react-query";

import {
  Dropzone,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "shipnow-mercurio";

import { cloudinaryPost } from "../../../../api/services/cloudinary.service";

const DEFAULT_PROPS = {
  label: "Cargando nueva imagen",
  onAddFile: () => {},
  onClose: () => {},
  show: false,
};

export const UploadImageModal = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };

  const toasts = useToast();

  const imageMutation = useMutation({
    mutationFn: (file) => cloudinaryPost(file),
    onError: () => {
      toasts.errorToast("Hubo un problema al subir la imagen");
    },
    onSuccess: (res) => {
      attrs.onAddFile(res.data.url);
    },
  });

  const handleAddFile = (files) => {
    const file = files[0];

    attrs.onClose();
    imageMutation.mutate({ img: file });
  };

  return (
    <Modal onClose={attrs.onClose} show={attrs.show} width="650px">
      <ModalHeader />

      <ModalContent>
        <Dropzone
          label={attrs.label}
          maxBitesSize={2000000}
          onFileAdd={handleAddFile}
          subtitle="Formatos aceptados: .jpeg, .jpg, .png ."
          validTypes={["jpeg", "jpg", "png"]}
        />
      </ModalContent>

      <ModalFooter className="pt-0 pb-1" />
    </Modal>
  );
};

UploadImageModal.propType = {
  label: PropTypes.string,
  onAddFile: PropTypes.func,
  onClose: PropTypes.func,
  show: PropTypes.bool,
};
